<template>
<div>
  <div class="wistia_embed wistia_async_kqct9dw1yc">
    &nbsp;
  </div>

  <div
    id="bz-places"
    class="tbk-vid-embed"
  >
    <a
      id="nicoya"
      class="embedded_video"
      href="#wistia_p69ex800zh?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="ikaria"
      class="embedded_video"
      href="#wistia_ss3ruaj8l5?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="sardinia"
      class="embedded_video"
      href="#wistia_zfg1oaj9e0?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="okinawa"
      class="embedded_video"
      href="#wistia_het9y0eojq?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="loma_linda"
      class="embedded_video"
      href="#wistia_z2i4wvy5hy?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    // Show the Call-to-Action after each video
    _wq.push({
      kqc: this.showCTA,
      p69: this.showCTA,
      ss3: this.showCTA,
      zfg: this.showCTA,
      het: this.showCTA,
      z2i: this.showCTA
    })

    if (this.tbk.isMobile()) {
      _wq.push({
        p69: this.tbk.autoPlay,
        ss3: this.tbk.autoPlay,
        zfg: this.tbk.autoPlay,
        het: this.tbk.autoPlay,
        z2i: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showCTA(video) {
      video.bind('end', function() {
        $('#bz-places').show()
      })
    }
  }
}
</script>

<style scoped lang="sass">
#bz-places
  display: none
  background-image: url('~./bluezones-tour.jpg')
  background-size: cover
  position: absolute
  width: 100%
  height: 100%
  a
    text-decoration: none
#nicoya
  position: absolute
  top: calc(100% * (250 / 360))
  left: calc(100% * (65 / 640))
  width: calc(100% * (75 / 640))
  height: calc(100% * (75 / 360))
#ikaria
  position: absolute
  top: calc(100% * (250 / 360))
  left: calc(100% * (490 / 640))
  width: calc(100% * (75 / 640))
  height: calc(100% * (75 / 360))
#sardinia
  position: absolute
  top: calc(100% * (145 / 360))
  left: calc(100% * (170 / 640))
  width: calc(100% * (75 / 640))
  height: calc(100% * (75 / 360))
#okinawa
  position: absolute
  top: calc(100% * (145 / 360))
  left: calc(100% * (380 / 640))
  width: calc(100% * (75 / 640))
  height: calc(100% * (75 / 360))
#loma_linda
  position: absolute
  top: calc(100% * (250 / 360))
  left: calc(100% * (265 / 640))
  width: calc(100% * (100 / 640))
  height: calc(100% * (75 / 360))
</style>
